























import Vue from 'vue'

export default Vue.extend({
    name: 'Navbar',
    props: { cases: Array },
    data(){
        return { currentCase: null }
    },
    methods: {
        setProgressWidth(width:number){
            try {
                (<HTMLElement>this.$refs.scroll_progress).style.width = width + '%'
            } catch(e) {
                console.groupCollapsed('Scroll progress bar not inited')
                console.warn(e)
                console.groupEnd()
                window.removeEventListener('scroll', this.handleScroll)
            }
        },
        handleScroll(e:Event){
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 100;
            this.setProgressWidth(scrolled)
        }
    },
    watch: {
        '$route'(to, from){
            this.currentCase = to.params.caseId
            if(this.currentCase){
                window.addEventListener('scroll', this.handleScroll)
                this.setProgressWidth(0)
            } else {
                window.removeEventListener('scroll', this.handleScroll)
                this.setProgressWidth(100)
            }
        }
    }
})
